import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'iot-platform-ui-chat-conversation-loader',
  imports: [MatButtonModule, MatIconModule, FlexLayoutModule],
  templateUrl: './chat-conversation-loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './chat-conversation-loader.component.scss'
})
export class ChatConversationLoaderComponent {}
